@for (validationError of validationErrors; track validationError.error) {
	<div role="alert">
		<ng-container
			[ngTemplateOutlet]="validationError.display.template"
			[ngTemplateOutletContext]="{ $implicit: validationError.error }"
		/>
	</div>
}
